
import React, { BaseSyntheticEvent } from 'react';
import { CQAppConstant } from '../../../../../app-constants';
import { observer } from 'mobx-react';
import LayoutFieldsConfigController from '../../../layout-level-fields.controller';
import '../apply-rule-modal.css';
import { CQMasterDataStore } from '../../../../../store/cq-master-data.store';
import { CQAPIService } from '../../../../../services/http-api.service';
import { CQAppStore } from '../../../../../store/cq-app-store';

class OnLoadInvokeRulesModalComponent extends React.Component<any, any> {
    private readonly layoutFieldsConfigCtrl: LayoutFieldsConfigController;
    private cqService: CQAPIService;
    constructor(props: any) {
        super(props);
        this.layoutFieldsConfigCtrl = new LayoutFieldsConfigController();
        this.cqService = new CQAPIService();
        this.state = {
            actions: [
                {
                    action:
                        { name: '', ns: '' }
                }
            ],
            autoLaunchFlowList: []
        };
    }

    async componentDidMount() {
        try {
            CQAppStore.loader.setVisibility(true);
            const autoLaunchFlowList: any = await this.cqService.getAutoLaunchFlows();
            if (this.props.appliedRule) {
                const ruleObject = CQMasterDataStore.RuleElements.FieldRuleElement;
                const objectName: any = this.props.objectName;
                const ruleElement = { ...(ruleObject[objectName])[this.props.appliedRule] };

                if (ruleElement) {
                    this.setState({
                        actions: ruleElement.actions,
                        autoLaunchFlowList
                    });
                }
            } else {
                this.setState({
                    autoLaunchFlowList
                });
            }
            CQAppStore.loader.setVisibility(false);
        }
        catch (error : any) {
            this.props.toggleModalVisibility();
            CQAppStore.loader.setVisibility(false);
            const errorObj = {
                errorType: CQAppConstant.ERROR_CUSTOM,
                errorMessage: error.error ? error.error : error.message,
                errorStatus: error.status,
                componentName: ''
            };
            CQAppStore.error.dispatchError(errorObj);
        }
    }


    public render() {
        return (
            <>
                <div className="slds-grid slds-grid_vertical">
                    <h3 className="slds-m-bottom_small">Flow</h3>

                    {
                        this.state.actions.length !== 0 &&
                        this.state.actions.map((action: any, actionIndex: number) => {
                            return (
                                <React.Fragment key={actionIndex}>
                                    <div key={actionIndex} className="slds-grid slds-grid_vertical-align-center slds-gutters_x-small full-width rules-set">
                                        <div className="slds-col col-sm slds-m-bottom_small">{actionIndex + 1}</div>
                                        <div className="slds-col slds-size_8-of-12">
                                            <div className="slds-form-element">
                                                <div className="slds-form-element__control">
                                                    <div className="slds-select_container">
                                                        <select className="slds-select" id="select-01"
                                                            onChange={e => this.onFlowChanged(e, actionIndex)} value={action.action.name}>
                                                            
                                                                <option value="">Select flow</option>
                                                            {
                                                                this.state.autoLaunchFlowList.map((flowData: any, flowIndex: number) => <option key={flowIndex}
                                                                        value={flowData.Definition.DeveloperName}>{`${flowData.MasterLabel}`}
                                                                    </option>)
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="slds-col slds-size_2-of-12">
                                            <div className="slds-grid slds-m-bottom_xx-small">
                                                <button className="slds-button slds-button_icon slds-button_icon-border-filled slds-m-horizontal_small" onClick={() => {
                                                    this.addInvokeFlowAction();
                                                }}>
                                                    <i className="cq-icon-add"></i>
                                                </button>
                                                {
                                                    actionIndex > 0 && <button className="slds-button slds-button_icon slds-button_icon-border-filled" onClick={() => {
                                                        this.deleteInvokeFlowAction(actionIndex);
                                                    }}>
                                                        <i className="cq-icon-delete"></i>
                                                    </button>
                                                }

                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            );
                        })
                    }
                </div>
            </>
        );
    }


    /**
     * @private
     * @memberof OnInitInvokeActionsRulesModalComponent
     */
    private readonly onFlowChanged = (e: BaseSyntheticEvent, actionIndex: number) => {
        const actions = this.state.actions;
        const selectedFlow = this.state.autoLaunchFlowList.filter((flowDetails: any) => {
            return flowDetails.Definition.DeveloperName === e.target.value;
        });

        actions[actionIndex].action.name = selectedFlow[0].Definition.DeveloperName;
        if (selectedFlow[0].Definition.NamespacePrefix) {
            actions[actionIndex].action.ns = selectedFlow[0].Definition.NamespacePrefix;
        }
        this.setState({ actions }, () => {
            const stateObj = { actions: this.state.actions };
            this.updateRuleObject(CQAppConstant.ACTION, stateObj);
        });
    }

    /**
     * @private
     * @memberof OnInitInvokeActionsRulesModalComponent
     */
    private readonly addInvokeFlowAction = () => {
        const action = {
            action:
                { name: '', ns: '' }
        };
        const actions = [...this.state.actions];
        actions.push(action);
        this.setState({
            actions
        }, () => {
            const stateObj = { actions: this.state.actions };
            this.updateRuleObject(CQAppConstant.ACTION, stateObj);
        });
    }

    /**
     * @private
     * @memberof OnInitInvokeActionsRulesModalComponent
     */
    private readonly deleteInvokeFlowAction = (actionIndex: number) => {
        const actions = [...this.state.actions];
        actions.splice(actionIndex, 1);

        this.setState({
            actions
        }, () => {
            const stateObj = { actions: this.state.actions };
            this.updateRuleObject(CQAppConstant.ACTION, stateObj);
        });
    }


    /**
     * @private
     * @memberof OnInitInvokeActionsRulesModalComponent
     */
    private updateRuleObject = (ruleObjectProperty: string, ruleObjectValue: any) => {
        this.props.setRuleObject(ruleObjectValue);
        this.props.checkValidation(this.validateAddRuleForm());
    }


    /**
     * @private
     * @memberof OnInitInvokeActionsRulesModalComponent
     */
    private validateAddRuleForm = () => {
        const isValidForm = this.state.actions.every((action: any) => action.action.name !== '');

        return !isValidForm;
    }
}
export const OnLoadInvokeRulesModal = observer(OnLoadInvokeRulesModalComponent);
